import script from "./CountriesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CountriesView.vue?vue&type=script&setup=true&lang=js"

import "./CountriesView.vue?vue&type=style&index=0&id=310909a5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-310909a5"]])

export default __exports__